export const getStructureMetadata = (structure) => JSON.stringify({
  totalCost: structure.totalCost,
  totalHours: structure.totalHours,
  useMinMax: structure.settings.useMinMax,
  workTypes: structure.workTypes.map(({ id, name }) => ({ id, name })),
})